import React from "react";
import { Link } from "react-router-dom";
import "./TermsAndConditions.css";

export const TermsAndConditions = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <Link
          to="/"
          style={{
            display: "inline-block",
            marginBottom: "20px",
            padding: "10px 20px",
            backgroundColor: "#608dfd",
            color: "#fff",
            textDecoration: "none",
            borderRadius: "4px",
            fontFamily: '"Open Sans", sans-serif',
            fontSize: "14px",
            fontWeight: 500,
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#5ca9fb";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#608dfd";
          }}
        >
          <i className="fa fa-arrow-left" style={{ marginRight: "8px" }}></i>
          Back to Home
        </Link>
        <h1 className="terms-title">TERMS AND CONDITIONS</h1>

        <div className="terms-header-info">
          <p>
            <strong>Sikh Motorcycle Riders Canada</strong>
          </p>
          <p>
            <strong>Website:</strong>{" "}
            <a
              href="https://sikhmotorcycleriders.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://sikhmotorcycleriders.com/
            </a>
          </p>
          <p>
            <strong>Effective Date:</strong> January 25, 2026
          </p>
          <p>
            <strong>Last Updated:</strong> January 25, 2026
          </p>
        </div>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Sikh Motorcycle Riders Canada website (the
            "Website"), participating in events, or engaging in any services,
            platforms, or communications operated by Sikh Motorcycle Riders
            Canada ("the Association," "we," "us," "our"), you agree to be bound
            by these Terms and Conditions ("Terms").
          </p>
          <p>
            If you do not agree to these Terms, you must not use the Website or
            participate in Association activities.
          </p>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">2. Purpose of the Association</h2>
          <p>The Association exists to:</p>
          <ul className="terms-list">
            <li>Promote safe motorcycle riding</li>
            <li>Foster brotherhood and community</li>
            <li>Support charitable and cultural initiatives</li>
            <li>Uphold Sikh values of respect, service, and integrity</li>
          </ul>
          <p>
            Participation in the Association always requires adherence to these
            principles, both online and offline.
          </p>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">3. Eligibility</h2>
          <p>
            You must be at least <strong>16 years of age</strong> to use the
            Website or participate in Association activities unless accompanied
            by a guardian and approved by the Association.
          </p>
          <p>
            By participating, you confirm that all information you provide is
            accurate and truthful.
          </p>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">
            4. Membership and Account Responsibility
          </h2>

          <h3 className="terms-subheading">4.1 Registration</h3>
          <p>
            Some features may require registration. You are responsible for:
          </p>
          <ul className="terms-list">
            <li>Maintaining accurate account information</li>
            <li>Keeping your login credentials secure</li>
            <li>All activities under your account</li>
          </ul>

          <h3 className="terms-subheading">4.2 Termination of Membership</h3>
          <p>
            The Association reserves the right to suspend or terminate
            membership at its discretion if a member violates these Terms or
            acts contrary to the values and interests of the Association.
          </p>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">
            5. Code of Conduct (Zero Tolerance Policy)
          </h2>
          <p>
            All members, guests, and participants are required to conduct
            themselves with respect, dignity, and integrity.
          </p>

          <h3 className="terms-subheading">5.1 Prohibited Conduct</h3>
          <p>Prohibited conduct includes, but is not limited to:</p>
          <ul className="terms-list">
            <li>
              Harassment, intimidation, abuse, or threats (verbal, written, or
              physical)
            </li>
            <li>
              Discriminatory, hateful, or inflammatory language or behaviour
            </li>
            <li>
              Disruptive or unsafe conduct at events, rides, or online platforms
            </li>
            <li>Spreading false, misleading, or defamatory information</li>
            <li>Misuse of Association platforms or branding</li>
            <li>
              Any conduct that harms the unity, safety, or reputation of the
              Association
            </li>
          </ul>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">
            6. Misconduct and Actions Against the Association
          </h2>

          <h3 className="terms-subheading">6.1 Intolerable Offenses</h3>
          <p>
            Any form of <strong>misbehavior</strong> by a member or{" "}
            <strong>action taken against the Association</strong> that harms its
            reputation, operations, leadership, or community is considered an{" "}
            <strong>intolerable offense.</strong>
          </p>
          <p>This includes, but is not limited to:</p>
          <ul className="terms-list">
            <li>
              Public or private defamation of the Association or its members
            </li>
            <li>
              Attempts to damage the Association's credibility, reputation, or
              operations
            </li>
            <li>
              Creating division, hostility, or conflict within the community
            </li>
            <li>
              Harassment or threats toward Association leadership, volunteers,
              or members
            </li>
            <li>
              Taking legal, administrative, or public action against the
              Association without first attempting internal resolution, unless
              required by law
            </li>
            <li>
              Conduct that brings disrepute to the Association or violates Sikh
              values
            </li>
          </ul>

          <h3 className="terms-subheading">6.2 Disciplinary Actions</h3>
          <p>
            Where misconduct occurs, the Association may take one or more of the
            following actions, at its sole discretion and in accordance with
            Canadian law:
          </p>
          <ul className="terms-list">
            <li>Issue a formal warning</li>
            <li>Suspend membership (temporary or permanent)</li>
            <li>Remove the member from events or online platforms</li>
            <li>Terminate membership without refund or notice</li>
            <li>Restrict access to Association services</li>
            <li>Pursue legal remedies where appropriate</li>
          </ul>

          <h3 className="terms-subheading">
            6.3 Internal Dispute Resolution (Canadian Compliance)
          </h3>
          <p>
            Before initiating external complaints, public accusations, or legal
            action against the Association, members agree to make a good-faith
            effort to resolve disputes internally by submitting a written
            complaint to the Association's executive committee.
          </p>
          <p>
            This does not limit a member's legal rights where immediate legal
            action is required by law.
          </p>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">7. User Content</h2>
          <p>
            Members may submit content (photos, comments, posts, messages). By
            submitting content, you grant the Association a non-exclusive,
            royalty-free, worldwide licence to use, display, and distribute that
            content for community and promotional purposes.
          </p>
          <p>
            The Association reserves the right to remove any content that
            violates these Terms.
          </p>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">8. Intellectual Property</h2>
          <p>
            All Website content, branding, logos, and materials (excluding user
            content) are owned by the Association and protected under{" "}
            <strong>Canadian copyright and trademark law.</strong>
          </p>
          <p>
            You may not copy, reproduce, or distribute any content without prior
            written consent.
          </p>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">9. Disclaimers</h2>

          <h3 className="terms-subheading">9.1 No Warranty</h3>
          <p>
            The Website and services are provided "as is" and "as available,"
            without warranties of any kind.
          </p>

          <h3 className="terms-subheading">9.2 Community Information</h3>
          <p>
            Information shared by members is not verified. Participation is at
            your own risk.
          </p>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">
            10. Limitation of Liability (Canada-Compliant)
          </h2>
          <p>
            To the maximum extent permitted under Canadian law, the Association
            is not liable for:
          </p>
          <ul className="terms-list">
            <li>Indirect, incidental, or consequential damages</li>
            <li>Personal injury or property loss occurring during events</li>
            <li>Loss of data, revenue, or goodwill</li>
            <li>Actions or conduct of members or third parties</li>
          </ul>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">11. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless the Association, its
            directors, volunteers, and members from any claim, loss, or damage
            arising from:
          </p>
          <ul className="terms-list">
            <li>Your breach of these Terms</li>
            <li>Your conduct at events or online</li>
            <li>Your submitted content</li>
            <li>Your violation of any law or regulation</li>
          </ul>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">12. Governing Law and Jurisdiction</h2>
          <p>
            These Terms are governed by and interpreted in accordance with the
            laws of the Province of Alberta, Canada, and the applicable laws of
            Canada.
          </p>
          <p>
            You agree that any disputes will be resolved exclusively in the
            courts of Alberta.
          </p>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">13. Changes to These Terms</h2>
          <p>
            The Association may update these Terms at any time. Continued use of
            the Website or participation in activities after updates constitutes
            acceptance of the revised Terms.
          </p>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">14. Contact Information</h2>
          <p>For questions, concerns, or formal complaints, contact:</p>
          <p>
            <strong>Email:</strong> <em>info@sikhmotorcycleriders.com</em>
          </p>
          <p>
            <strong>Website:</strong>{" "}
            <a
              href="https://sikhmotorcycleriders.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://sikhmotorcycleriders.com/
            </a>
          </p>
          <p>
            <strong>Association:</strong> Sikh Motorcycle Riders Canada
          </p>
        </section>

        <hr className="terms-divider" />

        <section className="terms-section">
          <h2 className="terms-heading">
            Event Participation Waiver, Release, and Membership Conditions
          </h2>
          <p>
            This section forms part of the Terms and Conditions of Sikh
            Motorcycle Riders Canada and is legally binding upon all members and
            participants.
          </p>

          <h3 className="terms-subheading">1. Consideration and Agreement</h3>
          <p>
            In consideration of being granted membership in Sikh Motorcycle
            Riders Canada and being permitted to participate in any and all
            club-sponsored events, rides, functions, and activities
            (collectively, the "Events"), I agree to the following terms.
          </p>

          <h3 className="terms-subheading">
            2. Liability Release and Assumption of Risk
          </h3>
          <p>
            I acknowledge that participation in Events involves inherent risks,
            including but not limited to motorcycle operation, road hazards,
            weather conditions, mechanical failure, and interaction with other
            participants or the public. I knowingly and voluntarily assume all
            such risks, including the risk of serious injury or death.
          </p>
          <p>
            I hereby release, discharge, and hold harmless Sikh Motorcycle
            Riders Canada, its directors, officers, members, volunteers,
            sponsors, landowners, event hosts, and affiliates ("Released
            Parties") from any and all liability, claims, demands, actions, or
            causes of action arising out of or related to my participation in
            Events, including those caused by the negligence of the Released
            Parties, to the fullest extent permitted by Canadian law.
          </p>

          <h3 className="terms-subheading">3. Indemnification</h3>
          <p>
            I agree to indemnify and hold harmless the Released Parties from any
            claims, damages, losses, costs, or expenses (including legal fees)
            arising from my actions, conduct, or participation in Events, or
            from any breach of these Terms.
          </p>

          <h3 className="terms-subheading">4. Insurance Responsibility</h3>
          <p>
            I acknowledge that Sikh Motorcycle Riders Canada does not provide
            health, accident, or life insurance coverage for members. I am
            solely responsible for my own medical expenses, insurance, and
            property damage resulting from participation in Events.
          </p>

          <h3 className="terms-subheading">
            5. Authorization for Use of Information and Media
          </h3>
          <p>
            I authorize Sikh Motorcycle Riders Canada to collect and use my
            email address, mailing address, and phone number for club
            communications only. I also grant permission for the Association to
            use photographs or videos of me taken during Events for promotional
            or community purposes, including website and social media use.
          </p>

          <h3 className="terms-subheading">6. Membership Revocation</h3>
          <p>
            I acknowledge and agree that Sikh Motorcycle Riders Canada may
            revoke or suspend my membership at any time, without notice, for
            violation of these Terms, bylaws, or conduct standards.
          </p>

          <h3 className="terms-subheading">
            7. Logo, Patch, and Insignia Rules
          </h3>
          <p>
            The Sikh Motorcycle Riders Canada logo contains the Khanda, a sacred
            symbol of the Sikh faith, and must be treated with the utmost
            respect at all times.
          </p>
          <p>Members agree that:</p>
          <ul className="terms-list">
            <li>
              The logo must be worn, displayed, and stored in a respectful
              manner consistent with Sikh Motorcycle Riders Canada values
            </li>
            <li>No unauthorized modifications to the logo are permitted</li>
            <li>
              No additional patches may be worn on the same garment as the
              Association logo except for:
              <ul className="terms-list" style={{ marginTop: "10px" }}>
                <li>National flag patches</li>
                <li>Provincial flag patches</li>
                <li>City patches</li>
                <li>Motorcycle manufacturer or model patches</li>
              </ul>
            </li>
          </ul>
          <p>
            Violation of logo or insignia rules may result in disciplinary
            action, including immediate revocation of membership.
          </p>

          <h3 className="terms-subheading">8. Legal Effect</h3>
          <p>
            This waiver and release shall be binding upon my heirs, executors,
            administrators, and assigns and shall be governed by the laws of the
            Province of Alberta and the laws of Canada applicable therein.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
